// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__23CRC","imageUploader":"EGiftCard_imageUploader__Bk08q"};